import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface RoleEntry {
  name: string;
  description: string;
}

const ROLES: RoleEntry[] = [
  {
    name: "tool-admin",
    description:
      "Full control over the tool — can manage settings, members, and content.",
  },
  {
    name: "tool-manager",
    description:
      "Can manage day-to-day content and assign tool-member / tool-viewer roles.",
  },
  {
    name: "tool-member",
    description: "Standard read/write access to use the tool.",
  },
  {
    name: "tool-viewer",
    description: "Read-only access. Can view but not change anything.",
  },
  {
    name: "denied",
    description:
      "Explicitly blocked from using the tool, even if a default would otherwise grant access.",
  },
];

export function RoleLegend() {
  // Mobile: collapsed by default to save vertical space; user can expand.
  // Desktop (md+): always visible regardless of toggle state.
  const [open, setOpen] = useState(false);

  return (
    <div
      className={cn(
        "mb-6 rounded-md border border-slate-100 bg-blue-50/50 text-xs text-slate-600"
      )}
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between px-4 py-2 font-medium md:hidden"
        aria-expanded={open}
      >
        <span>Role reference</span>
        {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
      </button>
      <div className={cn("px-4 py-3", open ? "block" : "hidden md:block")}>
        <p className="mb-2 hidden font-medium text-slate-700 md:block">
          Role reference
        </p>
        <ul className="space-y-1.5">
          {ROLES.map((r) => (
            <li key={r.name}>
              <span className="font-semibold text-slate-700">{r.name}</span>
              <span className="text-slate-600"> — {r.description}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
